import type { FC } from 'react';

import {
  type NotificationFilterValues,
  notificationFilters,
  reminderFilters,
} from '@core/utils/notificationQueryParams';
import type { NotificationTab } from '@core/utils/notifications';
import { useSlabQuery } from '@web/hooks/useSlabQuery';
import { useNotificationPanel } from '@web/providers/NotificationPanelProvider/NotificationPanelProvider';

import { SlabTabs } from '../SlabTabs/SlabTabs';

type Props = {
  value: NotificationTab;
  onChange: (tab: NotificationTab) => void;
  search: string;
  filterValues: NotificationFilterValues;
};

export const NotificationCenterTabs: FC<Props> = ({ value, onChange, search, filterValues }) => {
  const { isOpen, scope, scopeObject } = useNotificationPanel();

  const { data: stats } = useSlabQuery(
    'GET notification stats',
    {
      queryParams: {
        notifications: {
          filterBy: notificationFilters({
            tab: 'inbox',
            search,
            scope,
            scopeObject,
            filterValues,
          }),
        },
        reminders: {
          filterBy: reminderFilters({ search, scope, scopeObject, filterValues }),
        },
      },
    },
    { enabled: isOpen },
  );

  return (
    <SlabTabs
      value={value}
      onChange={onChange}
      items={[
        { value: 'unread', label: 'Unread', count: stats?.unreadNotifications },
        { value: 'inbox', label: 'Inbox', count: stats?.totalNotifications },
        { value: 'scheduled', label: 'Scheduled', count: stats?.totalReminders },
      ]}
    />
  );
};
